import { RecipientsMutationTypes } from './types';

export const mutations = {
    [RecipientsMutationTypes.SetRecipients](state, {recipients}) {
        if (Array.isArray(recipients)) {
            state.recipients = { data: recipients, total: recipients.length }
            return
        }
        state.recipients = recipients || { data: [], total: 0 }
    },
    [RecipientsMutationTypes.SetEmptyRecipients](state) {
        state.recipients = { data: [], total: 0, query_total: 0 }
    },
    [RecipientsMutationTypes.SetChangedRecipient](state, {recipient}) {
        const list = state.recipients && state.recipients.data
        if (!Array.isArray(list) || !recipient) {
            return
        }
        const foundIndex = list.findIndex(item => item._id === recipient._id)
        if (foundIndex === -1) {
            return
        }
        list.splice(foundIndex, 1, recipient)
    },
    [RecipientsMutationTypes.SetDeletedRecipient](state, {id}) {
        const list = state.recipients && state.recipients.data
        if (!Array.isArray(list)) {
            return
        }
        const foundIndex = list.findIndex(item => item._id === id)
        if (foundIndex === -1) {
            return
        }
        list.splice(foundIndex, 1)
    },
    [RecipientsMutationTypes.SetResponse](state, response) {
        return state.response = response
    },
}
